enum OptionsPageFieldEnum {
    ASSURANCE_ANNULATION = 'assuranceAnnulation',
    PARTICIPANTS_BOX = 'participantsBox',
    ACCEPT_CONDITIONS = 'acceptConditions',
}

export default OptionsPageFieldEnum